/**
 * @generated SignedSource<<c8f518618707dcadb860e95b152865f1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductInfoComponentDetail_ProductInfoComponentDetailSchema$data = {
  readonly components: ReadonlyArray<{
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsComponent">;
  }> | null;
  readonly " $fragmentType": "ProductInfoComponentDetail_ProductInfoComponentDetailSchema";
};
export type ProductInfoComponentDetail_ProductInfoComponentDetailSchema$key = {
  readonly " $data"?: ProductInfoComponentDetail_ProductInfoComponentDetailSchema$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductInfoComponentDetail_ProductInfoComponentDetailSchema">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductInfoComponentDetail_ProductInfoComponentDetailSchema",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "components",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProductDetailsComponent"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentDetailSchema",
  "abstractKey": null
};

(node as any).hash = "fbdb39c3da2e9b1a42b8458ddbc65e32";

export default node;
